export const profile = {
  name: "大岛优香",
  nameEn: "Oshima Yuka",
  avatar:
    "https://readdy.ai/api/search-image?query=elegant%20editorial%20portrait%20style%20of%20a%20serene%20young%20woman%20in%20soft%20cream%20knitwear%2C%20warm%20natural%20window%20light%2C%20minimal%20neutral%20background%2C%20refined%20and%20graceful%20atmosphere%2C%20high%20detail&width=800&height=1000&seq=yn-profile-01&orientation=portrait",
  tagline: "演员 · 综艺常驻 · 公益项目发起人",
  birthday: "1995 年 3 月 12 日",
  nationality: "日本",
  occupation: "演员 / 主持人",
  height: "165 cm",
  debut: "2014 年",
  agency: "微光演艺经纪",
  intro:
    "大岛优香，演员、主持人。以细腻而有层次感的表演风格被观众熟知，作品横跨电影、电视剧与生活类综艺。她擅长在克制的情绪里传递力量，也因温暖真诚的公众形象成为许多人心中的「温柔标杆」。",
  experiences: [
    {
      year: "2014",
      text: "通过短篇电影正式出道，凭借自然真实的表演获得新锐演员提名。",
    },
    {
      year: "2017",
      text: "首次担纲电视剧女主角，在青春题材作品中崭露头角，被媒体称为「最会演哭戏的新人」。",
    },
    {
      year: "2020",
      text: "主演文艺电影《纸鸢》，入围多个国际影展，演技获得广泛认可。",
    },
    {
      year: "2023",
      text: "回归生活类综艺，以真实松弛的状态圈粉，展现演员之外的另一面。",
    },
    {
      year: "2025",
      text: "凭《逆光而行》中的突破性表演斩获年度最佳女演员，迎来事业重要节点。",
    },
    {
      year: "2026",
      text: "发起艺术教育公益项目，并官宣多部新作，持续拓展表演边界。",
    },
  ],
  socials: [
    {
      name: "官方微博",
      handle: "@大岛优香",
      url: "#",
      icon: "ri-weibo-fill",
    },
    {
      name: "Instagram",
      handle: "@oshima_yuka",
      url: "#",
      icon: "ri-instagram-line",
    },
    {
      name: "YouTube",
      handle: "大岛优香官方频道",
      url: "#",
      icon: "ri-youtube-line",
    },
    {
      name: "官方邮箱",
      handle: "contact@oshima-yuka.example",
      url: "#",
      icon: "ri-mail-line",
    },
  ],
  stats: [
    { label: "影视作品", value: "20+" },
    { label: "主演剧集", value: "8" },
    { label: "获奖提名", value: "12" },
    { label: "从业年限", value: "12 年" },
  ],
};